import request from '@/utils/request'

export function fetchList(parentId, params) {
  return request({
    url:'/cashCategory/list/' + parentId,
    method:'get',
    params:params
  })
}
export function deleteCategory(id,params) {
  return request({
    url:'/cashCategory/delete/' + id,
    method:'post',
    params: params
  })
}

export function createCategory(data) {
  return request({
    url:'/cashCategory/create',
    method:'post',
    data:data
  })
}

export function updateCategory(id, data) {
  return request({
    url:'/cashCategory/update/' + id,
    method:'post',
    data:data
  })
}

export function fetchListWithChildren() {
  return request({
    url:'/cashCategory/list/withChildren',
    method:'get'
  })
}
